import { ModalPayload } from "../reducers/modal";

export type MODAL_ACTION_TYPES = ModalAction;

export enum MODAL_ACTIONS {
  MODAL_OPENED = "MODAL_OPENED",
  MODAL_CLOSED = "MODAL_CLOSED",
}

export type ModalAction = {
  type: MODAL_ACTIONS.MODAL_OPENED | MODAL_ACTIONS.MODAL_CLOSED
  payload?: ModalPayload
}

export const doOpenModal = (payload: ModalPayload): ModalAction => {
  return {
    type: MODAL_ACTIONS.MODAL_OPENED,
    payload
  }
}

export const doCloseModal = (): ModalAction => {
  return {
    type: MODAL_ACTIONS.MODAL_CLOSED
  }
}